<template>
    <NotificationsV2
        :isMobile="isMobile"
        initialTab="inbox"
        :inPage="true"
        @set-current-date="$emit('set-current-date', $event)"
    />
</template>

<script>
    import NotificationsV2 from '@/components/notifications/NotificationsV2'

    export default {
        name: 'Inbox',
        components: { 
            NotificationsV2
         },
        props: {
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        data(){
        	return {
                inPage: true
        	}
        },
        mounted(){
            // this.inPage=window.innerWidth<800
        },
        //computed: {},
        //watch: {},
        //methods: {},
    }
</script>